module.exports = __webpack_public_path__ + "static/media/spotify.b6b6b4cc.png";